import React, {Component} from "react"
import styled, {css} from "styled-components"
import PropTypes from "prop-types"

import ProfilePic from "@irati/ui/src/ProfilePicture"

export const DEFAULT_PICTURE_SIZE = "80px"

export const LARGE_TROPHY_SIZE = "75px"
export const DEFAULT_TROPHY_SIZE = "45px"
export const MOBILE_TROPHY_SIZE = "30px"

const StyledContainer = styled.div`
  position: relative;
  width: ${({size}) => (typeof size === "string" ? size : `${size}px`)};
`

const StyledTrophy = styled.img`
  position: absolute;
  border-radius: 50%;
  ${({offset, size, theme}) => css`
    border: 4px solid ${theme.colors.utility.white};
    background: ${theme.colors.utility.white};
    top: ${offset};
    right: ${offset};
    height: ${size};
    width: ${size};
  `}
`

class ProfilePicWithTrophy extends Component {
  static propTypes = {
    trophy: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    size: PropTypes.string,
    trophySize: PropTypes.string
  }

  static defaultProps = {
    size: DEFAULT_PICTURE_SIZE,
    trophySize: DEFAULT_TROPHY_SIZE
  }

  getOffset = (trophySize) => {
    if (trophySize === LARGE_TROPHY_SIZE) {
      return "-25px"
    }
    if (trophySize === DEFAULT_TROPHY_SIZE) {
      return "-15px"
    }
    return "-7.5px"
  }

  render() {
    const {user, trophy, size, trophySize} = this.props

    return (
      <StyledContainer size={size}>
        <StyledTrophy src={trophy.href} size={trophySize} offset={this.getOffset(trophySize)} />
        <ProfilePic user={user} size={size} />
      </StyledContainer>
    )
  }
}

export default ProfilePicWithTrophy
